export default __webpack_public_path__ + "static/media/drone.28538677.png";